import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-ui-components-category-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './category-image.component.html',
  styleUrl: './category-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryImageComponent {
  image = input.required();
  size = input<'56' | '64' | '84'>('64');
}
